export class ZeroArray extends Array {
    constructor(len) {
        super(len);
        for (let i = 0; i < len; i++) {
            this[i] = 0;
        }
    }
}
//# sourceMappingURL=ZeroArray.js.map